import { render } from "./market-school.vue?vue&type=template&id=3486b0ef"
import script from "./market-school.js?vue&type=script&lang=js"
export * from "./market-school.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__